import config from 'config';
import tmpl from './search.phtml';
import View from 'lib/View';
import Map from 'view/map';

export default View.extend({
	template: tmpl,

	events: {
	},

	hintIdle: 'Sélectionnez la mare que vous souhaitez décrire sur la carte',
	hintLoading: 'Chargement en cours…',

	initialize: function()
	{
		this.map = new Map();
		this.listenToOnce( this.map, 'render', this.initializeMap );
		this.listenTo( this.map, 'viewport:loading', this.showLoadingHint );
		this.listenTo( this.map, 'viewport:loaded', this.showIdleHint );
		this.geolocation = app.getStore('geolocation');
	},

	initializeMap: function()
	{
		// Mise à jour de la position
		this.listenTo( this.geolocation, 'latlng error', function( latlng )
		{
			this.map.setPositionText( latlng );
		});

		// Mise à jour de la position
		this.listenTo( this.geolocation, 'error', function( error )
		{
			this.map.setPositionError( error );
		});
	},

	showLoadingHint: function()
	{
		this.$( '.js-map-hint' ).text( this.hintLoading );
	},

	showIdleHint: function()
	{
		this.$( '.js-map-hint' ).text( this.hintIdle );
	},

	render: function()
	{
		this.doRender();

		this.map.setElement('#map');
		this.map.render({
			draggable: false,
			label: 'Votre position actuelle :'
		});
	},

	unload: function()
	{
		this.map.unload();
		this.map.remove();
		this.doUnload();
	}
});
